import axios from './HTTP'

export default {
  create(params) {
    return axios.post(`/api/todos.json`, { todo_item: params })
  },

  getMine () {
    return axios.get(`/api/todos/mine.json`)
  },

  getManaged (employeeID) {
    return axios.get(`/api/todos/managed.json`, { params: { employeeID: employeeID } })
  },

  update (todoID, params) {
    return axios.patch(`/api/todos/${ todoID }.json`, { todo_item: params })
  },

  remind (todoID) {
    return axios.post(`/api/todos/${ todoID }/remind.json`)
  },

  getOverdueCount (userID) {
    return axios.get('/api/todos/overdue.json', { params: { userID: userID } })
  },
}
